import React from 'react'
import GenericGrid from '../../sharedcomponents/5templates/commonGrid/GenericGrid'
import GridWrapper from '../../sharedcomponents/5templates/commonGrid/GridWrapper'
import useGridWrapper from '../../sharedcomponents/5templates/commonGrid/useGridWrapper'
import useGroup from './useGroup'

const FeatureGroups = () => {
  const defaultFetchParameter = {
    include: ['counts'],
    sort: '+name',
    type: 'feature',
    page: 0,
    per_page: 20
  }
  const {
    typeIdToDisplayName,
    loadGroups,
    bulkUpdateGroupsCallBack,
    groupTypes
  } = useGroup()

  const {
    editMode,
    setEditMode,
    isSnackbarOpen,
    setIsSnackbarOpen,
    deletionChanges,
    deleteCallBack,
    activationChanges,
    activationCallBack,
    detailCallBack,
    addCallBack,
    handSaveCallback,
    isGridDirty
  } = useGridWrapper('Feature Group', bulkUpdateGroupsCallBack)

  const visibleColumns = [
    { field: 'name', headerName: 'Name', width: 200, sortable: true },
    {
      field: 'type',
      headerName: 'Type',
      width: 100,
      sortable: true
    },
    {
      field: 'description',
      headerName: 'Description',
      width: 400,
      sortable: true
    },
    {
      field: 'total_feature',
      headerName: 'Features',
      width: 100,
      sortable: true
    },

    {
      field: 'active',
      headerName: 'Status',
      width: 225,
      sortable: true,
      isToggle: true
    }
  ]

  const fetchCallBack = async arg => {
    const {
      data: { data, pagination, sort } = {
        data: [],
        pagination: {},
        sort: {}
      },
      isError,
      isLoading,
      isFetching
    } = await loadGroups(arg)
    // transform the server-provided array for display

    const rows = []
    data.forEach(one => {
      rows.push({
        id: one.id, //please note, the underlying datagrid assumes the id column is always called id
        name: one.name,
        type: one.is_system ? 'System' : 'Business',
        description: one.description,
        total_feature: one.stats?.find(r => r.type === 'feature')?.count,
        active: one.suspended_at ? false : true,
        is_system: one.is_system
      })
    })

    return {
      newRows: rows,
      newPagination: pagination,
      newSort: sort,
      newLoading: isLoading || isFetching,
      newError: isError
    }
  }

  return (
    <div style={{ height: '100%', width: '100%' }}>
      <div style={{ height: '100%', width: '100%' }}>
        <GridWrapper
          header={'Feature Groups'}
          editMode={editMode}
          setEditMode={setEditMode}
          isSnackbarOpen={isSnackbarOpen}
          setIsSnackbarOpen={setIsSnackbarOpen}
          isGridDirty={isGridDirty}
          addCallBack={addCallBack}
          listOfTypes={groupTypes}
          typeToTypeDisplayName={typeIdToDisplayName}
          handleSave={handSaveCallback}
          containedEntityType={'feature'}
        >
          <GenericGrid
            initialFetchParameters={defaultFetchParameter}
            visibleColumns={visibleColumns}
            editMode={editMode}
            fetchCallBack={fetchCallBack}
            detailCallBack={detailCallBack}
            deleteCallBack={deleteCallBack}
            activationCallBack={activationCallBack}
            deletionChanges={deletionChanges}
            activationChanges={activationChanges}
            systemRowActionMessage='System groups cannot be deleted or suspended.'
            systemRowLabel='System group'
          />
        </GridWrapper>
      </div>
    </div>
  )
}
export default React.memo(FeatureGroups)
